<template>
    <v-layout column
              style="height: 380px;">
        <label class="headline font-weight-bold">
            {{title}}
        </label>
        <v-card class="elevation-0" style="height: 350px; width: 90%;">
            <v-fade-transition mode="out-in">
                <v-overlay v-model="loading" color="white" absolute key="loader">
                    <v-progress-circular color="secondary" indeterminate/>
                </v-overlay>
            </v-fade-transition>

            <GChart
                    type="ColumnChart"
                    style="width :100%; height :100%; margin-left :-5px; margin-top: 20px;"
                    :data="formatedData"
                    :options="chartOptions"
            />
        </v-card>
    </v-layout>
</template>

<script>
    import {GChart} from 'vue-google-charts'

    export default {
        name: "stacked-chart",
        components: {GChart},
        props: {
            title: {
                type: String,
                required: true
            },
            loading: {
                type: Boolean
            },
            data: {
                type: Array
            },
            stacks: {
                type: Array,
                required: true
            }
        },
        computed: {
            chartMaxValue() {
                return this.formatedData[1] ? (this.formatedData[1][1] + this.formatedData[1][2]) * 1.1 : 0
            },
            chartOptions() {
                return {
                    animation: {
                        startup: true,
                        duration: 500
                    },
                    bar: {groupWidth: "97%"},
                    legend: { position: 'bottom', maxLines: 1, alignment: 'start' },
                    colors: ['#BDBDBD', '#E0E0E0'],
                    isStacked: 'percent',
                    vAxis: {
                        textPosition: 'none',
                        gridlines: {
                            color: 'transparent'
                        },
                        maxValue: this.chartMaxValue
                    },
                    hAxis: {
                        textStyle: {'textAlign': 'left'}
                    },
                    chartArea: {
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: 300
                    },
                    annotations: {
                        alwaysOutside: true,
                        textStyle: {
                            fontName: 'Times-Roman',
                            color: "black"
                        }
                    }
                }
            },
            formatedData() {
                const stacks = this.stacks.map(v => ({"label": v}));
                console.log([["", ...stacks, {role: 'annotation'}], ...this.data])
                return [["", ...stacks, {role: 'annotation'}], ...this.data]
            }
        }
    }
</script>

<style scoped>

</style>